var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, EventEmitter, OnChanges, OnDestroy, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ProfessionNotListedPopupComponent } from './profession-not-listed-popup/profession-not-listed-popup.component';
import { LanguageService } from '@services/language.service';
import { ProfessionService } from '@services/profession.service';
import { ProvinceService } from '@services/province.service';
import { TitleService } from './../../_services/title.service';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { CommonDialogService } from '@services/common-dialog.service';
import { KjValidators } from '@shared/kj-validators/kj-validators';
var PersonalDetailsComponent = /** @class */ (function () {
    function PersonalDetailsComponent(formBuilder, dialog, commonDialogService, languageService, professionService, provinceService, titleService, authService) {
        var _this = this;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.commonDialogService = commonDialogService;
        this.languageService = languageService;
        this.professionService = professionService;
        this.provinceService = provinceService;
        this.titleService = titleService;
        this.authService = authService;
        this.readonly = false;
        this.submitUserProfile = new EventEmitter();
        this.maxDate = new Date();
        this.destroy$ = new Subject();
        this.maxAge = 100;
        this.defaultAge = 30;
        this.yearOfBirthOptions = new Array(this.maxAge).fill(0).map(function (y, i) { return _this.maxDate.getFullYear() - _this.maxAge + i; });
        this.postalCodeMatchesProvinceValidator = function (addressFormGroup) {
            if (_this.isPostalProvinceValid(addressFormGroup))
                return null;
            return { provincePostalCodeMismatch: true };
        };
        this.setupForm();
        this.filteredYearOfBirthOptions$ = this.form.controls.yearOfBirth.valueChanges.pipe(startWith(''), map(function (value) { return _this.yearOfBirthOptions.filter(function (year) { return year.toString().includes(value); }); }));
    }
    /**
     * Called when the year of birth selection box opens
     * If the value is null, scroll to the default age.
     * @returns
     */
    PersonalDetailsComponent.prototype.yearOfBirthOpen = function () {
        if (this.form.value.yearOfBirth !== null)
            return;
        // Get the item to scroll to
        var selItem = document.querySelector("mat-option.year-of-birth:nth-child(" + (this.maxAge - this.defaultAge) + ")");
        selItem.scrollIntoView({
            block: 'center'
        });
    };
    PersonalDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.titleService
            .getTitles()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (titles) {
            _this.titles = titles;
            _this.titleOtherId = _this.getParam(_this.titles, 'Other', 'id', 'type');
        });
        this.languageService.getLanguages().subscribe(function (languages) {
            _this.languages = languages;
        });
        this.languageService.getKnownLanguages().subscribe(function (languages) {
            _this.knownLanguages = languages;
        });
        this.professionService
            .getProfessions()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (professions) {
            _this.professions = professions;
        });
        this.provinceService
            .getProvinces()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (provinces) {
            _this.provinces = provinces;
            _this.addressForm.updateValueAndValidity();
        });
    };
    PersonalDetailsComponent.prototype.select = function (value, type) {
        var _this = this;
        setTimeout(function (_) { return _this["txt" + type + "Other"].nativeElement.focus(); }, 100);
    };
    PersonalDetailsComponent.prototype.clearOther = function (type) {
        this.form.controls[type + "Id"].setValue(null);
        this.form.controls[type + "Other"].setValue(null);
    };
    /**
     * Search an array of options by a parameter and return another parameter.
     * @param o The array of options that are available.
     * @param searchFor The value of the parameter to search for.
     * @param returnParam The name of the parameter whose value we want.
     * @param searchParam The name of the parameter to search by.
     */
    PersonalDetailsComponent.prototype.getParam = function (o, searchFor, returnParam, searchParam) {
        if (returnParam === void 0) { returnParam = 'label'; }
        if (searchParam === void 0) { searchParam = 'id'; }
        return o && searchFor ? o.find(function (x) { return x[searchParam] === searchFor; })[returnParam] : null;
    };
    PersonalDetailsComponent.prototype.getTitle = function () {
        return this.getParam(this.titles, this.userProfile.titleId);
    };
    PersonalDetailsComponent.prototype.getProvince = function () {
        return this.getParam(this.provinces, this.userProfile.address.provinceId);
    };
    PersonalDetailsComponent.prototype.getProfession = function () {
        return this.getParam(this.professions, this.userProfile.professionId);
    };
    PersonalDetailsComponent.prototype.getCommLanguage = function () {
        return this.getParam(this.languages, this.userProfile.communicationLanguageId, 'code');
    };
    PersonalDetailsComponent.prototype.getMotherTongue = function () {
        return this.getParam(this.knownLanguages, this.userProfile.maternalLanguageId);
    };
    PersonalDetailsComponent.prototype.ngOnChanges = function (changes) {
        if (changes.userProfile) {
            this.bindForm();
        }
    };
    PersonalDetailsComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    };
    PersonalDetailsComponent.prototype.submit = function () {
        if (this.form.invalid && this.authService.getUserId() === this.userProfile.id) {
            this.form.markAsTouched();
            return false;
        }
        var data = __assign({}, this.form.value);
        data.address.country = 'Canada';
        data.address.postalCode = data.address.postalCode.trim().toUpperCase();
        // prevents unsaved changes guard to be triggered
        this.form.markAsPristine();
        this.addressForm.markAsPristine();
        this.submitUserProfile.emit(data);
    };
    PersonalDetailsComponent.prototype.bindForm = function () {
        //  Clear the form before patching new values as some values could be missing and the form would keep the previous one.
        this.form.reset();
        this.form.patchValue(this.userProfile);
    };
    PersonalDetailsComponent.prototype.setupForm = function () {
        this.addressForm = this.formBuilder.group({
            streetName: new FormControl('', Validators.required),
            city: new FormControl('', Validators.required),
            provinceId: new FormControl('', Validators.required),
            postalCode: new FormControl('', [Validators.required, this.validatePostalCode])
        }, {
            validators: this.postalCodeMatchesProvinceValidator
        });
        this.form = this.formBuilder.group({
            id: new FormControl(''),
            titleId: new FormControl('', Validators.required),
            titleOther: new FormControl(''),
            firstName: new FormControl('', Validators.required),
            lastName: new FormControl('', Validators.required),
            yearOfBirth: new FormControl('', [
                Validators.required,
                Validators.min(this.maxDate.getFullYear() - this.maxAge),
                Validators.max(this.maxDate.getFullYear()),
                KjValidators.positiveWholeNumberValidator
            ]),
            maternalLanguageId: new FormControl('', Validators.required),
            address: this.addressForm,
            communicationLanguageId: new FormControl('', Validators.required),
            professionId: new FormControl('', Validators.required),
            isAgreedToTOS: new FormControl('', this.validateAgreementToTOS)
        }, {
            validators: [this.validateOtherFactory('title')]
        });
    };
    // Create a validator function for fields that have an OTHER option.
    PersonalDetailsComponent.prototype.validateOtherFactory = function (type) {
        var _this = this;
        return function (fg) {
            var _a;
            if (fg.controls[type + "Id"].value === _this[type + "OtherId"])
                if (!fg.controls[type + "Other"].value || !fg.controls[type + "Other"].value.trim().length) {
                    fg.controls[type + "Other"].setErrors({ empty: true });
                    return _a = {}, _a[type + "Empty"] = true, _a;
                }
            return null;
        };
    };
    PersonalDetailsComponent.prototype.validateAgreementToTOS = function (c) {
        if (c.value)
            return null;
        return {
            mustAgreeToTOS: {
                valid: false
            }
        };
    };
    /**
     * Make sure the postal code is in the correct format.
     * @param c The control that we're testing
     */
    PersonalDetailsComponent.prototype.validatePostalCode = function (c) {
        if (!c.value)
            return null;
        var POSTALCODE_EXP = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ -]?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;
        return POSTALCODE_EXP.test(c.value.trim().toUpperCase())
            ? null
            : {
                validatePostalCode: {
                    valid: false
                }
            };
    };
    PersonalDetailsComponent.prototype.showPostalCodeWarning = function () {
        return !this.isPostalProvinceValid(this.addressForm);
    };
    /**
     * Make sure the postal code is valid for the selected province.
     * @returns true if the postal code matches the province or both fields are not yet populated.
     * false otherwise.
     */
    PersonalDetailsComponent.prototype.isPostalProvinceValid = function (addressFormGroup) {
        if (this.provinces) {
            /*
              A Newfoundland Labrador
              B Nova Scotia
              C PEI
              E New Brunswick
      
              G Eastern PQ
              H Montreal PQ
              J Western PQ
      
              K Eastern Ont
              L Northern GTO Ont
              M Southern GTO Ont
              N Southern Ont
              P Northern Ont
      
              R Manitoba
              S Sask
              T Alberta
              V BC
              X NWT & Nunavut
              Y Yukon
                  */
            var provincePostalCodeMap = {
                NL: ['A'],
                NS: ['B'],
                PE: ['C'],
                NB: ['E'],
                QC: ['G', 'H', 'J'],
                ON: ['K', 'L', 'M', 'N', 'P'],
                MB: ['R'],
                SK: ['S'],
                AB: ['T'],
                BC: ['V'],
                YT: ['Y'],
                NT: ['X'],
                NU: ['X']
            };
            var prov = this.provinces.find(function (p) { return p.id === addressFormGroup.controls.provinceId.value; });
            if (prov && prov.shortName && addressFormGroup.controls.postalCode.value) {
                var firstLetter = addressFormGroup.controls.postalCode.value[0].toUpperCase();
                if (provincePostalCodeMap[prov.shortName].includes(firstLetter)) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        // No provinces, no validation
        return true;
    };
    PersonalDetailsComponent.prototype.openDialog = function () {
        this.dialog.open(ProfessionNotListedPopupComponent);
    };
    return PersonalDetailsComponent;
}());
export { PersonalDetailsComponent };
